export { default } from "./squaber";
